/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы торговой марки "Дарите Счастье"
   */
  app.DariteSchastieView = app.View.extend({
    el: '[data-jsmodel = "darite-schastie"]',

    events: {
      'click .slide-tm_spec .link_next': 'scrollToCatalog'
    },

    run: function () {
      var $main = this.$('.slide-tm_header');
      var $spec = this.$('.slide-tm_spec');
      $main.show();
      $spec.show();
    },

    /**
     * @param e
     */
    scrollToCatalog: function (e) {
      e.preventDefault();
      $('html, body').animate({scrollTop: this.$('.title_home').offset().top}, 500);
    }

  });
})(jQuery);

}.call(window));